import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Constants} from '../../../shared/config/constants.config';
import {Router} from '@angular/router';
import {StarsService} from '../../../shared/services/stars.service';
import {InfluencerViewModel} from '../../../shared/viewModels/stars.viewModel';

@Component({
    selector: 'app-stars',
    templateUrl: './stars.component.html',
    styleUrls: ['./stars.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StarsComponent implements OnInit {
    influencers: InfluencerViewModel[] = [];

    constructor(
        private readonly starsService: StarsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        readonly constants: Constants,
        public readonly router: Router,
    ) {
    }

    ngOnInit() {
        this.loadMore();
    }

    loadMore() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.starsService.getInfluencers().subscribe(influencers => {
            this.influencers = influencers;

            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.changeDetectorRef.markForCheck();
        });
    }

}
